module.exports = __webpack_public_path__ + "img/atlanta-logo-icon.feaecea2.png";